import { render } from "./HeaderLayer.vue?vue&type=template&id=3f22f1b1&scoped=true"
import script from "./HeaderLayer.vue?vue&type=script&lang=js"
export * from "./HeaderLayer.vue?vue&type=script&lang=js"

import "./HeaderLayer.vue?vue&type=style&index=0&id=3f22f1b1&lang=less&scoped=true"

import exportComponent from "F:\\work\\projects\\HiOmics\\Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f22f1b1"]])

export default __exports__